export const getStyled = (theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: 'auto',
    ...theme.custom.scrollbarStyles,
    backgroundColor: theme.custom.colors.defaultBackground,

    borderColor: theme.palette.mode === 'light' ? '#192734' : '#8C939A',
    color: ` ${theme.custom.colors.text} !important`,

    '& .MuiTableCell-root': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiTypography-root': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiIconButton-root': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiAvatar-root': {
      color: `${theme.custom.colors.text} !important`,
    },
  },
  editButton: {
    color: '#FFF',
    backgroundColor: theme.custom.colors.editButton,
    marginLeft: theme.spacing(1),
  },
  headerTitle: {
    color:
      theme.palette.mode === 'dark'
        ? '#FFF !important'
        : theme.palette.primary.main,
  },

  searchField: {
    '& .MuiInputBase-root': {
      color: theme.custom.colors.text,
    },
    '& .MuiInputBase-input': {
      color: theme.custom.colors.text,
    },
    '& .MuiInputAdornment-root': {
      color: theme.custom.colors.text,
    },
    '& .MuiInput-root:before': {
      borderBottomColor: theme.custom.colors.text,
    },
    '& .MuiInput-root:hover:not(.Mui-disabled):before': {
      borderBottomColor: theme.custom.colors.text,
    },
    '& .MuiInput-root:after': {
      borderBottomColor: theme.custom.colors.text,
    },
  },
});
